import CampaignsService from 'src/services/campaigns'

export default {
  fetchPaginated (payload = {}) {
    this.status = 'loading'
    let page = payload.page || 1
    if (page === 1 && this.campaigns.length > 0) {
      this.campaigns = []
    }

    const promise = CampaignsService.fetchPaginated(payload)

    promise.then(data => {
      const value = Array.isArray(data) ? [] : data.data
      this.campaigns = value
      this.status = 'success'
    })
      .catch(err => {
        console.error(err)
      })

    return promise
  },
  create (payload) {
    payload.locations = JSON.stringify(payload.locations)
    const promise = CampaignsService.create(payload)

    promise.catch(err => console.error('ERROR', err))

    return promise
  },
  update (payload) {
    payload.locations = JSON.stringify(payload.locations)
    const promise = CampaignsService.update(payload.id, payload)

    promise.catch(err => console.error('ERROR', err))

    return promise
  },
  delete (id) {
    const promise = CampaignsService.delete(id)
    this.campaigns = this.campaigns.filter(campaign => campaign.id !== id)

    promise.catch(err => console.error('ERROR', err))

    return promise
  }
}
